var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Grid',{staticClass:"app-promo-grid d-lg-none",attrs:{"grid":_vm.pwaGrid}})
}
var staticRenderFns = []

export { render, staticRenderFns }